const countries = [
  {
    id: 1,
    name: 'Afghanistan',
    slug: 'afghanistan',
    iso: 'AF',
    iso3: 'AFG',
    flag: '🇦🇫',
    number_code: '4',
    phone_code: '93',
    currency: 'AFN',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:19',
  },
  {
    id: 2,
    name: 'Aland Islands',
    slug: 'aland-islands',
    iso: 'AX',
    iso3: 'ALA',
    flag: '🇦🇽',
    number_code: '248',
    phone_code: '358',
    currency: '',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:19',
  },
  {
    id: 3,
    name: 'Albania',
    slug: 'albania',
    iso: 'AL',
    iso3: 'ALB',
    flag: '🇦🇱',
    number_code: '8',
    phone_code: '355',
    currency: 'ALL',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:19',
  },
  {
    id: 4,
    name: 'Algeria',
    slug: 'algeria',
    iso: 'DZ',
    iso3: 'DZA',
    flag: '🇩🇿',
    number_code: '12',
    phone_code: '213',
    currency: 'DZD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:19',
  },
  {
    id: 5,
    name: 'American Samoa',
    slug: 'american-samoa',
    iso: 'AS',
    iso3: 'ASM',
    flag: '🇦🇸',
    number_code: '16',
    phone_code: '1684',
    currency: 'USD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:19',
  },
  {
    id: 6,
    name: 'Andorra',
    slug: 'andorra',
    iso: 'AD',
    iso3: 'AND',
    flag: '🇦🇩',
    number_code: '20',
    phone_code: '376',
    currency: 'EUR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:19',
  },
  {
    id: 7,
    name: 'Angola',
    slug: 'angola',
    iso: 'AO',
    iso3: 'AGO',
    flag: '🇦🇴',
    number_code: '24',
    phone_code: '244',
    currency: 'AOA',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:19',
  },
  {
    id: 8,
    name: 'Anguilla',
    slug: 'anguilla',
    iso: 'AI',
    iso3: 'AIA',
    flag: '🇦🇮',
    number_code: '660',
    phone_code: '1264',
    currency: 'XCD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:19',
  },
  {
    id: 9,
    name: 'Antarctica',
    slug: 'antarctica',
    iso: 'AQ',
    iso3: null,
    flag: '',
    number_code: null,
    phone_code: '0',
    currency: '',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:19',
  },
  {
    id: 10,
    name: 'Antigua And Barbuda',
    slug: 'antigua-and-barbuda',
    iso: 'AG',
    iso3: 'ATG',
    flag: '🇦🇬',
    number_code: '28',
    phone_code: '1268',
    currency: 'XCD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:19',
  },
  {
    id: 11,
    name: 'Argentina',
    slug: 'argentina',
    iso: 'AR',
    iso3: 'ARG',
    flag: '🇦🇷',
    number_code: '32',
    phone_code: '54',
    currency: 'ARS',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:19',
  },
  {
    id: 12,
    name: 'Armenia',
    slug: 'armenia',
    iso: 'AM',
    iso3: 'ARM',
    flag: '🇦🇲',
    number_code: '51',
    phone_code: '374',
    currency: 'AMD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:19',
  },
  {
    id: 13,
    name: 'Aruba',
    slug: 'aruba',
    iso: 'AW',
    iso3: 'ABW',
    flag: '🇦🇼',
    number_code: '533',
    phone_code: '297',
    currency: 'AWG',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:19',
  },
  {
    id: 14,
    name: 'Asia Pacific Region',
    slug: 'asia-pacific-region',
    iso: 'AP',
    iso3: '0',

    flag: '',
    number_code: '0',
    phone_code: '0',
    currency: '',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:19',
  },
  {
    id: 15,
    name: 'Australia',
    slug: 'australia',
    iso: 'AU',
    iso3: 'AUS',
    flag: '🇦🇺',
    number_code: '36',
    phone_code: '61',
    currency: 'AUD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:19',
  },
  {
    id: 16,
    name: 'Austria',
    slug: 'austria',
    iso: 'AT',
    iso3: 'AUT',
    flag: '🇦🇹',
    number_code: '40',
    phone_code: '43',
    currency: 'EUR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:19',
  },
  {
    id: 17,
    name: 'Azerbaijan',
    slug: 'azerbaijan',
    iso: 'AZ',
    iso3: 'AZE',
    flag: '🇦🇿',
    number_code: '31',
    phone_code: '994',
    currency: 'AZN',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:19',
  },
  {
    id: 18,
    name: 'Bahamas',
    slug: 'bahamas',
    iso: 'BS',
    iso3: 'BHS',
    flag: '🇧🇸',
    number_code: '44',
    phone_code: '1242',
    currency: 'BSD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:19',
  },
  {
    id: 19,
    name: 'Bahrain',
    slug: 'bahrain',
    iso: 'BH',
    iso3: 'BHR',
    flag: '🇧🇭',
    number_code: '48',
    phone_code: '973',
    currency: 'BHD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:19',
  },
  {
    id: 20,
    name: 'Bangladesh',
    slug: 'bangladesh',
    iso: 'BD',
    iso3: 'BGD',
    flag: '🇧🇩',
    number_code: '50',
    phone_code: '880',
    currency: 'BDT',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 21,
    name: 'Barbados',
    slug: 'barbados',
    iso: 'BB',
    iso3: 'BRB',
    flag: '🇧🇧',
    number_code: '52',
    phone_code: '1246',
    currency: 'BBD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 22,
    name: 'Belarus',
    slug: 'belarus',
    iso: 'BY',
    iso3: 'BLR',
    flag: '🇧🇾',
    number_code: '112',
    phone_code: '375',
    currency: 'BYR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 23,
    name: 'Belgium',
    slug: 'belgium',
    iso: 'BE',
    iso3: 'BEL',
    flag: '🇧🇪',
    number_code: '56',
    phone_code: '32',
    currency: 'EUR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 24,
    name: 'Belize',
    slug: 'belize',
    iso: 'BZ',
    iso3: 'BLZ',
    flag: '🇧🇿',
    number_code: '84',
    phone_code: '501',
    currency: 'BZD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 25,
    name: 'Benin',
    slug: 'benin',
    iso: 'BJ',
    iso3: 'BEN',
    flag: '🇧🇯',
    number_code: '204',
    phone_code: '229',
    currency: 'XOF',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 26,
    name: 'Bermuda',
    slug: 'bermuda',
    iso: 'BM',
    iso3: 'BMU',
    flag: '🇧🇲',
    number_code: '60',
    phone_code: '1441',
    currency: 'BMD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 27,
    name: 'Bhutan',
    slug: 'bhutan',
    iso: 'BT',
    iso3: 'BTN',
    flag: '🇧🇹',
    number_code: '64',
    phone_code: '975',
    currency: 'BTN',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 28,
    name: 'Bolivia',
    slug: 'bolivia',
    iso: 'BO',
    iso3: 'BOL',
    flag: '🇧🇴',
    number_code: '68',
    phone_code: '591',
    currency: 'BOB',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 29,
    name: 'Bonaire, Sint Eustatius And Saba',
    slug: 'bonaire-sint-eustatius-and-saba',
    iso: 'BQ',
    iso3: 'BES',
    flag: '🇧🇶',
    number_code: '535',
    phone_code: '599',
    currency: '',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 30,
    name: 'Bosnia And Herzegovina',
    slug: 'bosnia-and-herzegovina',
    iso: 'BA',
    iso3: 'BIH',
    flag: '🇧🇦',
    number_code: '70',
    phone_code: '387',
    currency: 'BAM',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 31,
    name: 'Botswana',
    slug: 'botswana',
    iso: 'BW',
    iso3: 'BWA',
    flag: '🇧🇼',
    number_code: '72',
    phone_code: '267',
    currency: 'BWP',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 32,
    name: 'Bouvet Island',
    slug: 'bouvet-island',
    iso: 'BV',
    iso3: null,

    flag: '',
    number_code: null,
    phone_code: '0',
    currency: '',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 33,
    name: 'Brazil',
    slug: 'brazil',
    iso: 'BR',
    iso3: 'BRA',
    flag: '🇧🇷',
    number_code: '76',
    phone_code: '55',
    currency: 'BRL',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 34,
    name: 'British Indian Ocean Territory',
    slug: 'british-indian-ocean-territory',
    iso: 'IO',
    iso3: null,
    flag: '🇮🇴',
    number_code: null,
    phone_code: '246',
    currency: 'USD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 35,
    name: 'Brunei Darussalam',
    slug: 'brunei-darussalam',
    iso: 'BN',
    iso3: 'BRN',
    flag: '🇧🇳',
    number_code: '96',
    phone_code: '673',
    currency: 'BND',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 36,
    name: 'Bulgaria',
    slug: 'bulgaria',
    iso: 'BG',
    iso3: 'BGR',
    flag: '🇧🇬',
    number_code: '100',
    phone_code: '359',
    currency: 'BGN',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 37,
    name: 'Burkina Faso',
    slug: 'burkina-faso',
    iso: 'BF',
    iso3: 'BFA',
    flag: '🇧🇫',
    number_code: '854',
    phone_code: '226',
    currency: 'XOF',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 38,
    name: 'Burundi',
    slug: 'burundi',
    iso: 'BI',
    iso3: 'BDI',
    flag: '🇧🇮',
    number_code: '108',
    phone_code: '257',
    currency: 'BIF',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 39,
    name: 'Cambodia',
    slug: 'cambodia',
    iso: 'KH',
    iso3: 'KHM',
    flag: '🇰🇭',
    number_code: '116',
    phone_code: '855',
    currency: 'KHR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 40,
    name: 'Cameroon',
    slug: 'cameroon',
    iso: 'CM',
    iso3: 'CMR',
    flag: '🇨🇲',
    number_code: '120',
    phone_code: '237',
    currency: 'XAF',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 41,
    name: 'Canada',
    slug: 'canada',
    iso: 'CA',
    iso3: 'CAN',
    flag: '🇨🇦',
    number_code: '124',
    phone_code: '1',
    currency: 'CAD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 42,
    name: 'Cape Verde',
    slug: 'cape-verde',
    iso: 'CV',
    iso3: 'CPV',
    flag: '🇨🇻',
    number_code: '132',
    phone_code: '238',
    currency: 'CVE',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 43,
    name: 'Cayman Islands',
    slug: 'cayman-islands',
    iso: 'KY',
    iso3: 'CYM',
    flag: '🇰🇾',
    number_code: '136',
    phone_code: '1345',
    currency: 'KYD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 44,
    name: 'Central African Republic',
    slug: 'central-african-republic',
    iso: 'CF',
    iso3: 'CAF',
    flag: '🇨🇫',
    number_code: '140',
    phone_code: '236',
    currency: 'XAF',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 45,
    name: 'Chad',
    slug: 'chad',
    iso: 'TD',
    iso3: 'TCD',
    flag: '🇹🇩',
    number_code: '148',
    phone_code: '235',
    currency: 'XAF',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 46,
    name: 'Chile',
    slug: 'chile',
    iso: 'CL',
    iso3: 'CHL',
    flag: '🇨🇱',
    number_code: '152',
    phone_code: '56',
    currency: 'CLP',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 47,
    name: 'China',
    slug: 'china',
    iso: 'CN',
    iso3: 'CHN',
    flag: '🇨🇳',
    number_code: '156',
    phone_code: '86',
    currency: 'CNY',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 48,
    name: 'Christmas Island',
    slug: 'christmas-island',
    iso: 'CX',
    iso3: null,
    flag: '🇨🇽',
    number_code: null,
    phone_code: '61',
    currency: 'AUD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 49,
    name: 'Cocos (Keeling) Islands',
    slug: 'cocos-keeling-islands',
    iso: 'CC',
    iso3: null,
    flag: '🇨🇨',
    number_code: null,
    phone_code: '672',
    currency: 'AUD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 50,
    name: 'Colombia',
    slug: 'colombia',
    iso: 'CO',
    iso3: 'COL',
    flag: '🇨🇴',
    number_code: '170',
    phone_code: '57',
    currency: 'COP',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 51,
    name: 'Comoros',
    slug: 'comoros',
    iso: 'KM',
    iso3: 'COM',
    flag: '🇰🇲',
    number_code: '174',
    phone_code: '269',
    currency: 'KMF',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 52,
    name: 'Congo',
    slug: 'congo',
    iso: 'CG',
    iso3: 'COG',
    flag: '🇨🇬',
    number_code: '178',
    phone_code: '242',
    currency: 'XAF',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 53,
    name: 'Democratic Republic of the Congo',
    slug: 'democratic-republic-of-the-congo',
    iso: 'CD',
    iso3: 'COD',
    flag: '🇨🇩',
    number_code: '180',
    phone_code: '242',
    currency: 'CDF',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 54,
    name: 'Cook Islands',
    slug: 'cook-islands',
    iso: 'CK',
    iso3: 'COK',
    flag: '🇨🇰',
    number_code: '184',
    phone_code: '682',
    currency: '',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 55,
    name: 'Costa Rica',
    slug: 'costa-rica',
    iso: 'CR',
    iso3: 'CRI',
    flag: '🇨🇷',
    number_code: '188',
    phone_code: '506',
    currency: 'CRC',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 56,
    name: "Cote D'ivoire",
    slug: 'cote-divoire',
    iso: 'CI',
    iso3: 'CIV',
    flag: '🇨🇮',
    number_code: '384',
    phone_code: '225',
    currency: 'XOF',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 57,
    name: 'Croatia',
    slug: 'croatia',
    iso: 'HR',
    iso3: 'HRV',
    flag: '🇭🇷',
    number_code: '191',
    phone_code: '385',
    currency: 'HRK',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 58,
    name: 'Cuba',
    slug: 'cuba',
    iso: 'CU',
    iso3: 'CUB',
    flag: '',
    number_code: '192',
    phone_code: '53',
    currency: 'CUP',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 59,
    name: 'Curacao',
    slug: 'curacao',
    iso: 'CW',
    iso3: 'CUW',
    flag: '🇨🇼',
    number_code: '531',
    phone_code: '599',
    currency: '',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 60,
    name: 'Cyprus',
    slug: 'cyprus',
    iso: 'CY',
    iso3: 'CYP',
    flag: '🇨🇾',
    number_code: '196',
    phone_code: '357',
    currency: 'EUR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 61,
    name: 'Czech Republic',
    slug: 'czech-republic',
    iso: 'CZ',
    iso3: 'CZE',
    flag: '🇨🇿',
    number_code: '203',
    phone_code: '420',
    currency: 'CZK',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 62,
    name: 'Denmark',
    slug: 'denmark',
    iso: 'DK',
    iso3: 'DNK',
    flag: '🇩🇰',
    number_code: '208',
    phone_code: '45',
    currency: 'DKK',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 63,
    name: 'Djibouti',
    slug: 'djibouti',
    iso: 'DJ',
    iso3: 'DJI',
    flag: '🇩🇯',
    number_code: '262',
    phone_code: '253',
    currency: 'DJF',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 64,
    name: 'Dominica',
    slug: 'dominica',
    iso: 'DM',
    iso3: 'DMA',
    flag: '🇩🇲',
    number_code: '212',
    phone_code: '1767',
    currency: 'XCD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 65,
    name: 'Dominican Republic',
    slug: 'dominican-republic',
    iso: 'DO',
    iso3: 'DOM',
    flag: '🇩🇴',
    number_code: '214',
    phone_code: '1809',
    currency: 'DOP',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 66,
    name: 'Ecuador',
    slug: 'ecuador',
    iso: 'EC',
    iso3: 'ECU',
    flag: '🇪🇨',
    number_code: '218',
    phone_code: '593',
    currency: 'USD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 67,
    name: 'Egypt',
    slug: 'egypt',
    iso: 'EG',
    iso3: 'EGY',
    flag: '🇪🇬',
    number_code: '818',
    phone_code: '20',
    currency: 'EGP',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 68,
    name: 'El Salvador',
    slug: 'el-salvador',
    iso: 'SV',
    iso3: 'SLV',
    flag: '🇸🇻',
    number_code: '222',
    phone_code: '503',
    currency: 'USD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 69,
    name: 'Equatorial Guinea',
    slug: 'equatorial-guinea',
    iso: 'GQ',
    iso3: 'GNQ',
    flag: '🇬🇶',
    number_code: '226',
    phone_code: '240',
    currency: 'XAF',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 70,
    name: 'Eritrea',
    slug: 'eritrea',
    iso: 'ER',
    iso3: 'ERI',
    flag: '🇪🇷',
    number_code: '232',
    phone_code: '291',
    currency: 'ERN',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 71,
    name: 'Estonia',
    slug: 'estonia',
    iso: 'EE',
    iso3: 'EST',
    flag: '🇪🇪',
    number_code: '233',
    phone_code: '372',
    currency: 'EUR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 72,
    name: 'Ethiopia',
    slug: 'ethiopia',
    iso: 'ET',
    iso3: 'ETH',
    flag: '🇪🇹',
    number_code: '231',
    phone_code: '251',
    currency: 'ETB',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 73,
    name: 'Falkland Islands (Malvinas)',
    slug: 'falkland-islands-malvinas',
    iso: 'FK',
    iso3: 'FLK',
    flag: '🇫🇰',
    number_code: '238',
    phone_code: '500',
    currency: 'FKP',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 74,
    name: 'Faroe Islands',
    slug: 'faroe-islands',
    iso: 'FO',
    iso3: 'FRO',
    flag: '🇫🇴',
    number_code: '234',
    phone_code: '298',
    currency: '',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 75,
    name: 'Fiji',
    slug: 'fiji',
    iso: 'FJ',
    iso3: 'FJI',
    flag: '🇫🇯',
    number_code: '242',
    phone_code: '679',
    currency: 'FJD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 76,
    name: 'Finland',
    slug: 'finland',
    iso: 'FI',
    iso3: 'FIN',
    flag: '🇫🇮',
    number_code: '246',
    phone_code: '358',
    currency: 'EUR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 77,
    name: 'France',
    slug: 'france',
    iso: 'FR',
    iso3: 'FRA',
    flag: '🇫🇷',
    number_code: '250',
    phone_code: '33',
    currency: 'EUR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 78,
    name: 'French Guiana',
    slug: 'french-guiana',
    iso: 'GF',
    iso3: 'GUF',
    flag: '🇬🇫',
    number_code: '254',
    phone_code: '594',
    currency: 'EUR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 79,
    name: 'French Polynesia',
    slug: 'french-polynesia',
    iso: 'PF',
    iso3: 'PYF',
    flag: '🇵🇫',
    number_code: '258',
    phone_code: '689',
    currency: 'XPF',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 80,
    name: 'French Southern Territories',
    slug: 'french-southern-territories',
    iso: 'TF',
    iso3: null,

    flag: '',
    number_code: null,
    phone_code: '0',
    currency: '',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 81,
    name: 'Gabon',
    slug: 'gabon',
    iso: 'GA',
    iso3: 'GAB',
    flag: '🇬🇦',
    number_code: '266',
    phone_code: '241',
    currency: 'XAF',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 82,
    name: 'Gambia',
    slug: 'gambia',
    iso: 'GM',
    iso3: 'GMB',
    flag: '🇬🇲',
    number_code: '270',
    phone_code: '220',
    currency: 'GMD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 83,
    name: 'Georgia',
    slug: 'georgia',
    iso: 'GE',
    iso3: 'GEO',
    flag: '🇬🇪',
    number_code: '268',
    phone_code: '995',
    currency: 'GEL',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:20',
  },
  {
    id: 84,
    name: 'Germany',
    slug: 'germany',
    iso: 'DE',
    iso3: 'DEU',
    flag: '🇩🇪',
    number_code: '276',
    phone_code: '49',
    currency: 'EUR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 85,
    name: 'Ghana',
    slug: 'ghana',
    iso: 'GH',
    iso3: 'GHA',
    flag: '🇬🇭',
    number_code: '288',
    phone_code: '233',
    currency: 'GHS',
    currency_symbol: '₵',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 86,
    name: 'Gibraltar',
    slug: 'gibraltar',
    iso: 'GI',
    iso3: 'GIB',
    flag: '🇬🇮',
    number_code: '292',
    phone_code: '350',
    currency: 'GIP',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 87,
    name: 'Greece',
    slug: 'greece',
    iso: 'GR',
    iso3: 'GRC',
    flag: '🇬🇷',
    number_code: '300',
    phone_code: '30',
    currency: 'EUR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 88,
    name: 'Greenland',
    slug: 'greenland',
    iso: 'GL',
    iso3: 'GRL',
    flag: '🇬🇱',
    number_code: '304',
    phone_code: '299',
    currency: 'DKK',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 89,
    name: 'Grenada',
    slug: 'grenada',
    iso: 'GD',
    iso3: 'GRD',
    flag: '🇬🇩',
    number_code: '308',
    phone_code: '1473',
    currency: 'XCD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 90,
    name: 'Guadeloupe',
    slug: 'guadeloupe',
    iso: 'GP',
    iso3: 'GLP',
    flag: '🇬🇵',
    number_code: '312',
    phone_code: '590',
    currency: 'EUR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 91,
    name: 'Guam',
    slug: 'guam',
    iso: 'GU',
    iso3: 'GUM',
    flag: '🇬🇺',
    number_code: '316',
    phone_code: '1671',
    currency: 'USD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 92,
    name: 'Guatemala',
    slug: 'guatemala',
    iso: 'GT',
    iso3: 'GTM',
    flag: '🇬🇹',
    number_code: '320',
    phone_code: '502',
    currency: 'GTQ',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 93,
    name: 'Guernsey',
    slug: 'guernsey',
    iso: 'GG',
    iso3: 'GGY',
    flag: '🇬🇬',
    number_code: '831',
    phone_code: '44',
    currency: 'GGP',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 94,
    name: 'Guinea',
    slug: 'guinea',
    iso: 'GN',
    iso3: 'GIN',
    flag: '🇬🇳',
    number_code: '324',
    phone_code: '224',
    currency: 'GNF',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 95,
    name: 'Guinea-Bissau',
    slug: 'guinea-bissau',
    iso: 'GW',
    iso3: 'GNB',
    flag: '🇬🇼',
    number_code: '624',
    phone_code: '245',
    currency: 'XOF',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 96,
    name: 'Guyana',
    slug: 'guyana',
    iso: 'GY',
    iso3: 'GUY',
    flag: '🇬🇾',
    number_code: '328',
    phone_code: '592',
    currency: 'GYD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 97,
    name: 'Haiti',
    slug: 'haiti',
    iso: 'HT',
    iso3: 'HTI',
    flag: '🇭🇹',
    number_code: '332',
    phone_code: '509',
    currency: 'HTG',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 98,
    name: 'Heard Island And Mcdonald Islands',
    slug: 'heard-island-and-mcdonald-islands',
    iso: 'HM',
    iso3: null,
    flag: '🇭🇲',
    number_code: null,
    phone_code: '0',
    currency: '',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 99,
    name: 'Holy See (Vatican City State)',
    slug: 'holy-see-vatican-city-state',
    iso: 'VA',
    iso3: 'VAT',
    flag: '🇻🇦',
    number_code: '336',
    phone_code: '39',
    currency: 'EUR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 100,
    name: 'Honduras',
    slug: 'honduras',
    iso: 'HN',
    iso3: 'HND',
    flag: '🇭🇳',
    number_code: '340',
    phone_code: '504',
    currency: 'HNL',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 101,
    name: 'Hong Kong',
    slug: 'hong-kong',
    iso: 'HK',
    iso3: 'HKG',
    flag: '🇭🇰',
    number_code: '344',
    phone_code: '852',
    currency: 'HKD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 102,
    name: 'Hungary',
    slug: 'hungary',
    iso: 'HU',
    iso3: 'HUN',
    flag: '🇭🇺',
    number_code: '348',
    phone_code: '36',
    currency: 'HUF',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 103,
    name: 'Iceland',
    slug: 'iceland',
    iso: 'IS',
    iso3: 'ISL',
    flag: '🇮🇸',
    number_code: '352',
    phone_code: '354',
    currency: 'ISK',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 104,
    name: 'India',
    slug: 'india',
    iso: 'IN',
    iso3: 'IND',
    flag: '🇮🇳',
    number_code: '356',
    phone_code: '91',
    currency: 'INR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 105,
    name: 'Indonesia',
    slug: 'indonesia',
    iso: 'ID',
    iso3: 'IDN',
    flag: '🇮🇩',
    number_code: '360',
    phone_code: '62',
    currency: 'IDR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 106,
    name: 'Iran, Islamic Republic Of',
    slug: 'iran-islamic-republic-of',
    iso: 'IR',
    iso3: 'IRN',
    flag: '',
    number_code: '364',
    phone_code: '98',
    currency: 'IRR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 107,
    name: 'Iraq',
    slug: 'iraq',
    iso: 'IQ',
    iso3: 'IRQ',
    flag: '🇮🇶',
    number_code: '368',
    phone_code: '964',
    currency: 'IQD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 108,
    name: 'Ireland',
    slug: 'ireland',
    iso: 'IE',
    iso3: 'IRL',
    flag: '🇮🇪',
    number_code: '372',
    phone_code: '353',
    currency: 'EUR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 109,
    name: 'Isle Of Man',
    slug: 'isle-of-man',
    iso: 'IM',
    iso3: 'IMN',
    flag: '🇮🇲',
    number_code: '833',
    phone_code: '44',
    currency: 'IMP',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 110,
    name: 'Israel',
    slug: 'israel',
    iso: 'IL',
    iso3: 'ISR',
    flag: '🇮🇱',
    number_code: '376',
    phone_code: '972',
    currency: 'ILS',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 111,
    name: 'Italy',
    slug: 'italy',
    iso: 'IT',
    iso3: 'ITA',
    flag: '🇮🇹',
    number_code: '380',
    phone_code: '39',
    currency: 'EUR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 112,
    name: 'Jamaica',
    slug: 'jamaica',
    iso: 'JM',
    iso3: 'JAM',
    flag: '🇯🇲',
    number_code: '388',
    phone_code: '1876',
    currency: 'JMD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 113,
    name: 'Japan',
    slug: 'japan',
    iso: 'JP',
    iso3: 'JPN',
    flag: '🇯🇵',
    number_code: '392',
    phone_code: '81',
    currency: 'JPY',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 114,
    name: 'Jersey',
    slug: 'jersey',
    iso: 'JE',
    iso3: 'JEY',
    flag: '🇯🇪',
    number_code: '832',
    phone_code: '44',
    currency: 'JEP',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 115,
    name: 'Jordan',
    slug: 'jordan',
    iso: 'JO',
    iso3: 'JOR',
    flag: '🇯🇴',
    number_code: '400',
    phone_code: '962',
    currency: 'JOD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 116,
    name: 'Kazakhstan',
    slug: 'kazakhstan',
    iso: 'KZ',
    iso3: 'KAZ',
    flag: '🇰🇿',
    number_code: '398',
    phone_code: '7',
    currency: 'KZT',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 117,
    name: 'Kenya',
    slug: 'kenya',
    iso: 'KE',
    iso3: 'KEN',
    flag: '🇰🇪',
    number_code: '404',
    phone_code: '254',
    currency: 'KES',
    currency_symbol: '/=',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 118,
    name: 'Kiribati',
    slug: 'kiribati',
    iso: 'KI',
    iso3: 'KIR',
    flag: '🇰🇮',
    number_code: '296',
    phone_code: '686',
    currency: 'AUD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 119,
    name: "Korea, Democratic People's Republic",
    slug: 'korea-democratic-peoples-republic',
    iso: 'KP',
    iso3: 'PRK',
    flag: '',
    number_code: '408',
    phone_code: '850',
    currency: 'KRW',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 120,
    name: 'South Korea',
    slug: 'south-Korea',
    iso: 'KR',
    iso3: 'KOR',
    flag: '🇰🇷',
    number_code: '410',
    phone_code: '82',
    currency: 'KPW',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 121,
    name: 'Kosovo',
    slug: 'kosovo',
    iso: 'XK',
    iso3: '---',
    flag: '',
    number_code: '0',
    phone_code: '381',
    currency: 'EUR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 122,
    name: 'Kuwait',
    slug: 'kuwait',
    iso: 'KW',
    iso3: 'KWT',
    flag: '🇰🇼',
    number_code: '414',
    phone_code: '965',
    currency: 'KWD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 123,
    name: 'Kyrgyzstan',
    slug: 'kyrgyzstan',
    iso: 'KG',
    iso3: 'KGZ',
    flag: '🇰🇬',
    number_code: '417',
    phone_code: '996',
    currency: 'KGS',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 124,
    name: 'Lao Peoples Democratic Republic',
    slug: 'lao-peoples-democratic-republic',
    iso: 'LA',
    iso3: 'LAO',
    flag: '🇱🇦',
    number_code: '418',
    phone_code: '856',
    currency: 'LAK',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 125,
    name: 'Latvia',
    slug: 'latvia',
    iso: 'LV',
    iso3: 'LVA',
    flag: '🇱🇻',
    number_code: '428',
    phone_code: '371',
    currency: 'EUR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 126,
    name: 'Lebanon',
    slug: 'lebanon',
    iso: 'LB',
    iso3: 'LBN',
    flag: '🇱🇧',
    number_code: '422',
    phone_code: '961',
    currency: 'LBP',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 127,
    name: 'Lesotho',
    slug: 'lesotho',
    iso: 'LS',
    iso3: 'LSO',
    flag: '🇱🇸',
    number_code: '426',
    phone_code: '266',
    currency: 'LSL',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 128,
    name: 'Liberia',
    slug: 'liberia',
    iso: 'LR',
    iso3: 'LBR',
    flag: '🇱🇷',
    number_code: '430',
    phone_code: '231',
    currency: 'LRD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 129,
    name: 'Libyan Arab Jamahiriya',
    slug: 'libyan-arab-jamahiriya',
    iso: 'LY',
    iso3: 'LBY',
    flag: '🇱🇾',
    number_code: '434',
    phone_code: '218',
    currency: 'LYD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 130,
    name: 'Liechtenstein',
    slug: 'liechtenstein',
    iso: 'LI',
    iso3: 'LIE',
    flag: '🇱🇮',
    number_code: '438',
    phone_code: '423',
    currency: 'CHF',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 131,
    name: 'Lithuania',
    slug: 'lithuania',
    iso: 'LT',
    iso3: 'LTU',
    flag: '🇱🇹',
    number_code: '440',
    phone_code: '370',
    currency: 'EUR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 132,
    name: 'Luxembourg',
    slug: 'luxembourg',
    iso: 'LU',
    iso3: 'LUX',
    flag: '🇱🇺',
    number_code: '442',
    phone_code: '352',
    currency: 'EUR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 133,
    name: 'Macao',
    slug: 'macao',
    iso: 'MO',
    iso3: 'MAC',
    flag: '🇲🇴',
    number_code: '446',
    phone_code: '853',
    currency: '',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 134,
    name: 'Macedonia, The Former Yugoslav Republic Of',
    slug: 'macedonia-the-former-yugoslav-republic-of',
    iso: 'MK',
    iso3: 'MKD',
    flag: '🇲🇰',
    number_code: '807',
    phone_code: '389',
    currency: 'MKD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 135,
    name: 'Madagascar',
    slug: 'madagascar',
    iso: 'MG',
    iso3: 'MDG',
    flag: '🇲🇬',
    number_code: '450',
    phone_code: '261',
    currency: 'MGA',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 136,
    name: 'Malawi',
    slug: 'malawi',
    iso: 'MW',
    iso3: 'MWI',
    flag: '🇲🇼',
    number_code: '454',
    phone_code: '265',
    currency: 'MWK',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 137,
    name: 'Malaysia',
    slug: 'malaysia',
    iso: 'MY',
    iso3: 'MYS',
    flag: '🇲🇾',
    number_code: '458',
    phone_code: '60',
    currency: 'MYR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 138,
    name: 'Maldives',
    slug: 'maldives',
    iso: 'MV',
    iso3: 'MDV',
    flag: '🇲🇻',
    number_code: '462',
    phone_code: '960',
    currency: 'MVR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 139,
    name: 'Mali',
    slug: 'mali',
    iso: 'ML',
    iso3: 'MLI',
    flag: '🇲🇱',
    number_code: '466',
    phone_code: '223',
    currency: 'XOF',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 140,
    name: 'Malta',
    slug: 'malta',
    iso: 'MT',
    iso3: 'MLT',
    flag: '🇲🇹',
    number_code: '470',
    phone_code: '356',
    currency: 'EUR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 141,
    name: 'Marshall Islands',
    slug: 'marshall-islands',
    iso: 'MH',
    iso3: 'MHL',
    flag: '🇲🇭',
    number_code: '584',
    phone_code: '692',
    currency: 'USD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 142,
    name: 'Martinique',
    slug: 'martinique',
    iso: 'MQ',
    iso3: 'MTQ',
    flag: '🇲🇶',
    number_code: '474',
    phone_code: '596',
    currency: 'EUR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 143,
    name: 'Mauritania',
    slug: 'mauritania',
    iso: 'MR',
    iso3: 'MRT',
    flag: '🇲🇷',
    number_code: '478',
    phone_code: '222',
    currency: 'MRO',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 144,
    name: 'Mauritius',
    slug: 'mauritius',
    iso: 'MU',
    iso3: 'MUS',
    flag: '🇲🇺',
    number_code: '480',
    phone_code: '230',
    currency: 'MUR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 145,
    name: 'Mayotte',
    slug: 'mayotte',
    iso: 'YT',
    iso3: null,
    flag: '🇾🇹',
    number_code: null,
    phone_code: '269',
    currency: 'EUR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 146,
    name: 'Mexico',
    slug: 'mexico',
    iso: 'MX',
    iso3: 'MEX',
    flag: '🇲🇽',
    number_code: '484',
    phone_code: '52',
    currency: 'MXN',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 147,
    name: 'Micronesia, Federated States Of',
    slug: 'micronesia-federated-states-of',
    iso: 'FM',
    iso3: 'FSM',
    flag: '🇫🇲',
    number_code: '583',
    phone_code: '691',
    currency: 'USD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 148,
    name: 'Moldova, Republic Of',
    slug: 'moldova-republic-of',
    iso: 'MD',
    iso3: 'MDA',
    flag: '🇲🇩',
    number_code: '498',
    phone_code: '373',
    currency: 'MDL',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:21',
  },
  {
    id: 149,
    name: 'Monaco',
    slug: 'monaco',
    iso: 'MC',
    iso3: 'MCO',
    flag: '🇲🇨',
    number_code: '492',
    phone_code: '377',
    currency: 'EUR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 150,
    name: 'Mongolia',
    slug: 'mongolia',
    iso: 'MN',
    iso3: 'MNG',
    flag: '🇲🇳',
    number_code: '496',
    phone_code: '976',
    currency: 'MNT',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 151,
    name: 'Montenegro',
    slug: 'montenegro',
    iso: 'ME',
    iso3: 'MNE',
    flag: '🇲🇪',
    number_code: '499',
    phone_code: '382',
    currency: 'EUR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 152,
    name: 'Montserrat',
    slug: 'montserrat',
    iso: 'MS',
    iso3: 'MSR',
    flag: '🇲🇸',
    number_code: '500',
    phone_code: '1664',
    currency: 'XCD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 153,
    name: 'Morocco',
    slug: 'morocco',
    iso: 'MA',
    iso3: 'MAR',
    flag: '🇲🇦',
    number_code: '504',
    phone_code: '212',
    currency: 'MAD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 154,
    name: 'Mozambique',
    slug: 'mozambique',
    iso: 'MZ',
    iso3: 'MOZ',
    flag: '🇲🇿',
    number_code: '508',
    phone_code: '258',
    currency: 'MZN',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 155,
    name: 'Myanmar',
    slug: 'myanmar',
    iso: 'MM',
    iso3: 'MMR',
    flag: '🇲🇲',
    number_code: '104',
    phone_code: '95',
    currency: 'MMK',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 156,
    name: 'Namibia',
    slug: 'namibia',
    iso: 'NA',
    iso3: 'NAM',
    flag: '🇳🇦',
    number_code: '516',
    phone_code: '264',
    currency: 'NAD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 157,
    name: 'Nauru',
    slug: 'nauru',
    iso: 'NR',
    iso3: 'NRU',
    flag: '🇳🇷',
    number_code: '520',
    phone_code: '674',
    currency: 'AUD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 158,
    name: 'Nepal',
    slug: 'nepal',
    iso: 'NP',
    iso3: 'NPL',
    flag: '🇳🇵',
    number_code: '524',
    phone_code: '977',
    currency: 'NPR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 159,
    name: 'Netherlands',
    slug: 'netherlands',
    iso: 'NL',
    iso3: 'NLD',
    flag: '🇳🇱',
    number_code: '528',
    phone_code: '31',
    currency: 'EUR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 160,
    name: 'Netherlands Antilles',
    slug: 'netherlands-antilles',
    iso: 'AN',
    iso3: 'ANT',
    flag: '',
    number_code: '530',
    phone_code: '599',
    currency: '',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 161,
    name: 'New Caledonia',
    slug: 'new-caledonia',
    iso: 'NC',
    iso3: 'NCL',
    flag: '🇳🇨',
    number_code: '540',
    phone_code: '687',
    currency: 'XPF',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 162,
    name: 'New Zealand',
    slug: 'new-zealand',
    iso: 'NZ',
    iso3: 'NZL',
    flag: '🇳🇿',
    number_code: '554',
    phone_code: '64',
    currency: 'NZD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 163,
    name: 'Nicaragua',
    slug: 'nicaragua',
    iso: 'NI',
    iso3: 'NIC',
    flag: '🇳🇮',
    number_code: '558',
    phone_code: '505',
    currency: 'NIO',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 164,
    name: 'Niger',
    slug: 'niger',
    iso: 'NE',
    iso3: 'NER',
    flag: '🇳🇪',
    number_code: '562',
    phone_code: '227',
    currency: 'XOF',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 165,
    name: 'Nigeria',
    slug: 'nigeria',
    iso: 'NG',
    iso3: 'NGA',
    flag: '🇳🇬',
    number_code: '566',
    phone_code: '234',
    currency: 'NGN',
    currency_symbol: '₦',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 166,
    name: 'Niue',
    slug: 'niue',
    iso: 'NU',
    iso3: 'NIU',
    flag: '🇳🇺',
    number_code: '570',
    phone_code: '683',
    currency: 'NZD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 167,
    name: 'Norfolk Island',
    slug: 'norfolk-island',
    iso: 'NF',
    iso3: 'NFK',
    flag: '🇳🇫',
    number_code: '574',
    phone_code: '672',
    currency: 'AUD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 168,
    name: 'Northern Mariana Islands',
    slug: 'northern-mariana-islands',
    iso: 'MP',
    iso3: 'MNP',
    flag: '',
    number_code: '580',
    phone_code: '1670',
    currency: 'USD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 169,
    name: 'Norway',
    slug: 'norway',
    iso: 'NO',
    iso3: 'NOR',
    flag: '🇳🇴',
    number_code: '578',
    phone_code: '47',
    currency: 'NOK',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 170,
    name: 'Oman',
    slug: 'oman',
    iso: 'OM',
    iso3: 'OMN',
    flag: '🇴🇲',
    number_code: '512',
    phone_code: '968',
    currency: 'OMR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 171,
    name: 'Pakistan',
    slug: 'pakistan',
    iso: 'PK',
    iso3: 'PAK',
    flag: '🇵🇰',
    number_code: '586',
    phone_code: '92',
    currency: 'PKR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 172,
    name: 'Palau',
    slug: 'palau',
    iso: 'PW',
    iso3: 'PLW',
    flag: '🇵🇼',
    number_code: '585',
    phone_code: '680',
    currency: 'USD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 173,
    name: 'Palestinian Territory, Occupied',
    slug: 'palestinian-territory-occupied',
    iso: 'PS',
    iso3: null,

    flag: '',
    number_code: null,
    phone_code: '970',
    currency: '',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 174,
    name: 'Panama',
    slug: 'panama',
    iso: 'PA',
    iso3: 'PAN',
    flag: '🇵🇦',
    number_code: '591',
    phone_code: '507',
    currency: 'USD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 175,
    name: 'Papua New Guinea',
    slug: 'papua-new-guinea',
    iso: 'PG',
    iso3: 'PNG',
    flag: '🇵🇬',
    number_code: '598',
    phone_code: '675',
    currency: 'PGK',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 176,
    name: 'Paraguay',
    slug: 'paraguay',
    iso: 'PY',
    iso3: 'PRY',
    flag: '🇵🇾',
    number_code: '600',
    phone_code: '595',
    currency: 'PYG',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 177,
    name: 'Peru',
    slug: 'peru',
    iso: 'PE',
    iso3: 'PER',
    flag: '🇵🇪',
    number_code: '604',
    phone_code: '51',
    currency: 'PEN',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 178,
    name: 'Philippines',
    slug: 'philippines',
    iso: 'PH',
    iso3: 'PHL',
    flag: '🇵🇭',
    number_code: '608',
    phone_code: '63',
    currency: 'PHP',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 179,
    name: 'Pitcairn',
    slug: 'pitcairn',
    iso: 'PN',
    iso3: 'PCN',
    flag: '🇵🇳',
    number_code: '612',
    phone_code: '0',
    currency: 'NZD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 180,
    name: 'Poland',
    slug: 'poland',
    iso: 'PL',
    iso3: 'POL',
    flag: '🇵🇱',
    number_code: '616',
    phone_code: '48',
    currency: 'PLN',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 181,
    name: 'Portugal',
    slug: 'portugal',
    iso: 'PT',
    iso3: 'PRT',
    flag: '🇵🇹',
    number_code: '620',
    phone_code: '351',
    currency: 'EUR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 182,
    name: 'Puerto Rico',
    slug: 'puerto-rico',
    iso: 'PR',
    iso3: 'PRI',
    flag: '🇵🇷',
    number_code: '630',
    phone_code: '1787',
    currency: 'USD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 183,
    name: 'Qatar',
    slug: 'qatar',
    iso: 'QA',
    iso3: 'QAT',
    flag: '🇶🇦',
    number_code: '634',
    phone_code: '974',
    currency: 'QAR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 184,
    name: 'Reunion',
    slug: 'reunion',
    iso: 'RE',
    iso3: 'REU',
    flag: '🇷🇪',
    number_code: '638',
    phone_code: '262',
    currency: 'EUR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 185,
    name: 'Romania',
    slug: 'romania',
    iso: 'RO',
    iso3: 'ROM',
    flag: '🇷🇴',
    number_code: '642',
    phone_code: '40',
    currency: 'RON',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 186,
    name: 'Russian Federation',
    slug: 'russian-federation',
    iso: 'RU',
    iso3: 'RUS',
    flag: '',
    number_code: '643',
    phone_code: '70',
    currency: 'RUB',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 187,
    name: 'Rwanda',
    slug: 'rwanda',
    iso: 'RW',
    iso3: 'RWA',
    flag: '🇷🇼',
    number_code: '646',
    phone_code: '250',
    currency: 'RWF',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 188,
    name: 'Saint Barthelemy',
    slug: 'saint-barthelemy',
    iso: 'BL',
    iso3: 'BLM',
    flag: '🇧🇱',
    number_code: '652',
    phone_code: '590',
    currency: 'EUR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 189,
    name: 'Saint Helena',
    slug: 'saint-helena',
    iso: 'SH',
    iso3: 'SHN',
    flag: '🇸🇭',
    number_code: '654',
    phone_code: '290',
    currency: 'SHP',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 190,
    name: 'Saint Kitts And Nevis',
    slug: 'saint-kitts-and-nevis',
    iso: 'KN',
    iso3: 'KNA',
    flag: '🇰🇳',
    number_code: '659',
    phone_code: '1869',
    currency: 'XCD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 191,
    name: 'Saint Lucia',
    slug: 'saint-lucia',
    iso: 'LC',
    iso3: 'LCA',
    flag: '🇱🇨',
    number_code: '662',
    phone_code: '1758',
    currency: 'XCD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 192,
    name: 'Saint Martin',
    slug: 'saint-martin',
    iso: 'MF',
    iso3: 'MAF',
    flag: '🇲🇫',
    number_code: '663',
    phone_code: '590',
    currency: 'EUR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 193,
    name: 'Saint Pierre And Miquelon',
    slug: 'saint-pierre-and-miquelon',
    iso: 'PM',
    iso3: 'SPM',
    flag: '🇵🇲',
    number_code: '666',
    phone_code: '508',
    currency: 'EUR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 194,
    name: 'Saint Vincent And The Grenadines',
    slug: 'saint-vincent-and-the-grenadines',
    iso: 'VC',
    iso3: 'VCT',
    flag: '🇻🇨',
    number_code: '670',
    phone_code: '1784',
    currency: 'XCD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 195,
    name: 'Samoa',
    slug: 'samoa',
    iso: 'WS',
    iso3: 'WSM',
    flag: '🇼🇸',
    number_code: '882',
    phone_code: '684',
    currency: 'WST',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 196,
    name: 'San Marino',
    slug: 'san-marino',
    iso: 'SM',
    iso3: 'SMR',
    flag: '🇸🇲',
    number_code: '674',
    phone_code: '378',
    currency: 'EUR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 197,
    name: 'Sao Tome And Principe',
    slug: 'sao-tome-and-principe',
    iso: 'ST',
    iso3: 'STP',
    flag: '🇸🇹',
    number_code: '678',
    phone_code: '239',
    currency: 'STD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 198,
    name: 'Saudi Arabia',
    slug: 'saudi-arabia',
    iso: 'SA',
    iso3: 'SAU',
    flag: '🇸🇦',
    number_code: '682',
    phone_code: '966',
    currency: 'SAR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 199,
    name: 'Senegal',
    slug: 'senegal',
    iso: 'SN',
    iso3: 'SEN',
    flag: '🇸🇳',
    number_code: '686',
    phone_code: '221',
    currency: 'XOF',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 200,
    name: 'Serbia',
    slug: 'serbia',
    iso: 'RS',
    iso3: 'SRB',
    flag: '🇷🇸',
    number_code: '688',
    phone_code: '381',
    currency: 'RSD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 201,
    name: 'Serbia And Montenegro',
    slug: 'serbia-and-montenegro',
    iso: 'CS',
    iso3: null,

    flag: '',
    number_code: null,
    phone_code: '381',
    currency: 'EUR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 202,
    name: 'Seychelles',
    slug: 'seychelles',
    iso: 'SC',
    iso3: 'SYC',
    flag: '🇸🇨',
    number_code: '690',
    phone_code: '248',
    currency: 'SCR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 203,
    name: 'Sierra Leone',
    slug: 'sierra-leone',
    iso: 'SL',
    iso3: 'SLE',
    flag: '🇸🇱',
    number_code: '694',
    phone_code: '232',
    currency: 'SLL',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 204,
    name: 'Singapore',
    slug: 'singapore',
    iso: 'SG',
    iso3: 'SGP',
    flag: '🇸🇬',
    number_code: '702',
    phone_code: '65',
    currency: 'SGD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 205,
    name: 'Sint Maarten',
    slug: 'sint-maarten',
    iso: 'SX',
    iso3: 'SXM',
    flag: '🇸🇽',
    number_code: '534',
    phone_code: '1',
    currency: 'ANG',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 206,
    name: 'Slovakia',
    slug: 'slovakia',
    iso: 'SK',
    iso3: 'SVK',
    flag: '🇸🇰',
    number_code: '703',
    phone_code: '421',
    currency: 'EUR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 207,
    name: 'Slovenia',
    slug: 'slovenia',
    iso: 'SI',
    iso3: 'SVN',
    flag: '🇸🇮',
    number_code: '705',
    phone_code: '386',
    currency: 'EUR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 208,
    name: 'Solomon Islands',
    slug: 'solomon-islands',
    iso: 'SB',
    iso3: 'SLB',
    flag: '🇸🇧',
    number_code: '90',
    phone_code: '677',
    currency: 'SBD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 209,
    name: 'Somalia',
    slug: 'somalia',
    iso: 'SO',
    iso3: 'SOM',
    flag: '🇸🇴',
    number_code: '706',
    phone_code: '252',
    currency: 'SOS',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 210,
    name: 'South Africa',
    slug: 'south-africa',
    iso: 'ZA',
    iso3: 'ZAF',
    flag: '🇿🇦',
    number_code: '710',
    phone_code: '27',
    currency: 'ZAR',
    currency_symbol: 'R',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 211,
    name: 'South Georgia And The South Sandwich Islands',
    slug: 'south-georgia-and-the-south-sandwich-islands',
    iso: 'GS',
    iso3: null,
    flag: '🇬🇸',
    number_code: null,
    phone_code: '0',
    currency: '',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 212,
    name: 'South Sudan',
    slug: 'south-sudan',
    iso: 'SS',
    iso3: 'SSD',
    flag: '🇸🇸',
    number_code: '728',
    phone_code: '211',
    currency: 'SSP',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:22',
  },
  {
    id: 213,
    name: 'Spain',
    slug: 'spain',
    iso: 'ES',
    iso3: 'ESP',
    flag: '🇪🇸',
    number_code: '724',
    phone_code: '34',
    currency: 'EUR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 214,
    name: 'Sri Lanka',
    slug: 'sri-lanka',
    iso: 'LK',
    iso3: 'LKA',
    flag: '🇱🇰',
    number_code: '144',
    phone_code: '94',
    currency: 'LKR',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 215,
    name: 'Sudan',
    slug: 'sudan',
    iso: 'SD',
    iso3: 'SDN',
    flag: '',
    number_code: '736',
    phone_code: '249',
    currency: 'SDG',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 216,
    name: 'Suriname',
    slug: 'suriname',
    iso: 'SR',
    iso3: 'SUR',
    flag: '🇸🇷',
    number_code: '740',
    phone_code: '597',
    currency: 'SRD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 217,
    name: 'Svalbard And Jan Mayen',
    slug: 'svalbard-and-jan-mayen',
    iso: 'SJ',
    iso3: 'SJM',
    flag: '🇸🇯',
    number_code: '744',
    phone_code: '47',
    currency: 'NOK',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 218,
    name: 'Swaziland',
    slug: 'swaziland',
    iso: 'SZ',
    iso3: 'SWZ',
    flag: '🇸🇿',
    number_code: '748',
    phone_code: '268',
    currency: 'SZL',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 219,
    name: 'Sweden',
    slug: 'sweden',
    iso: 'SE',
    iso3: 'SWE',
    flag: '🇸🇪',
    number_code: '752',
    phone_code: '46',
    currency: 'SEK',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 220,
    name: 'Switzerland',
    slug: 'switzerland',
    iso: 'CH',
    iso3: 'CHE',
    flag: '🇨🇭',
    number_code: '756',
    phone_code: '41',
    currency: 'CHF',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 221,
    name: 'Syrian Arab Republic',
    slug: 'syrian-arab-republic',
    iso: 'SY',
    iso3: 'SYR',
    flag: '',
    number_code: '760',
    phone_code: '963',
    currency: 'SYP',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 222,
    name: 'Taiwan, Province Of China',
    slug: 'taiwan-province-of-china',
    iso: 'TW',
    iso3: 'TWN',
    flag: '🇹🇼',
    number_code: '158',
    phone_code: '886',
    currency: 'TWD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 223,
    name: 'Tajikistan',
    slug: 'tajikistan',
    iso: 'TJ',
    iso3: 'TJK',
    flag: '🇹🇯',
    number_code: '762',
    phone_code: '992',
    currency: 'TJS',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 224,
    name: 'Tanzania, United Republic Of',
    slug: 'tanzania-united-republic-of',
    iso: 'TZ',
    iso3: 'TZA',
    flag: '🇹🇿',
    number_code: '834',
    phone_code: '255',
    currency: 'TZS',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 225,
    name: 'Thailand',
    slug: 'thailand',
    iso: 'TH',
    iso3: 'THA',
    flag: '🇹🇭',
    number_code: '764',
    phone_code: '66',
    currency: 'THB',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 226,
    name: 'Timor-Leste',
    slug: 'timor-leste',
    iso: 'TL',
    iso3: null,
    flag: '🇹🇱',
    number_code: null,
    phone_code: '670',
    currency: 'USD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 227,
    name: 'Togo',
    slug: 'togo',
    iso: 'TG',
    iso3: 'TGO',
    flag: '🇹🇬',
    number_code: '768',
    phone_code: '228',
    currency: 'XOF',
    currency_symbol: 'CFA',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 228,
    name: 'Tokelau',
    slug: 'tokelau',
    iso: 'TK',
    iso3: 'TKL',
    flag: '🇹🇰',
    number_code: '772',
    phone_code: '690',
    currency: 'NZD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 229,
    name: 'Tonga',
    slug: 'tonga',
    iso: 'TO',
    iso3: 'TON',
    flag: '🇹🇴',
    number_code: '776',
    phone_code: '676',
    currency: 'TOP',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 230,
    name: 'Trinidad And Tobago',
    slug: 'trinidad-and-tobago',
    iso: 'TT',
    iso3: 'TTO',
    flag: '🇹🇹',
    number_code: '780',
    phone_code: '1868',
    currency: 'TTD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 231,
    name: 'Tunisia',
    slug: 'tunisia',
    iso: 'TN',
    iso3: 'TUN',
    flag: '🇹🇳',
    number_code: '788',
    phone_code: '216',
    currency: 'TND',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 232,
    name: 'Turkey',
    slug: 'turkey',
    iso: 'TR',
    iso3: 'TUR',
    flag: '🇹🇷',
    number_code: '792',
    phone_code: '90',
    currency: 'TRY',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 233,
    name: 'Turkmenistan',
    slug: 'turkmenistan',
    iso: 'TM',
    iso3: 'TKM',
    flag: '🇹🇲',
    number_code: '795',
    phone_code: '7370',
    currency: 'TMT',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 234,
    name: 'Turks And Caicos Islands',
    slug: 'turks-and-caicos-islands',
    iso: 'TC',
    iso3: 'TCA',
    flag: '🇹🇨',
    number_code: '796',
    phone_code: '1649',
    currency: 'USD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 235,
    name: 'Tuvalu',
    slug: 'tuvalu',
    iso: 'TV',
    iso3: 'TUV',
    flag: '🇹🇻',
    number_code: '798',
    phone_code: '688',
    currency: 'AUD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 236,
    name: 'Uganda',
    slug: 'uganda',
    iso: 'UG',
    iso3: 'UGA',
    flag: '🇺🇬',
    number_code: '800',
    phone_code: '256',
    currency: 'UGX',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 237,
    name: 'Ukraine',
    slug: 'ukraine',
    iso: 'UA',
    iso3: 'UKR',
    flag: '🇺🇦',
    number_code: '804',
    phone_code: '380',
    currency: 'UAH',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 238,
    name: 'United Arab Emirates',
    slug: 'united-arab-emirates',
    iso: 'AE',
    iso3: 'ARE',
    flag: '🇦🇪',
    number_code: '784',
    phone_code: '971',
    currency: 'AED',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 239,
    name: 'United Kingdom',
    slug: 'united-kingdom',
    iso: 'GB',
    iso3: 'GBR',
    flag: '🇬🇧',
    number_code: '826',
    phone_code: '44',
    currency: 'GBP',
    // currency_symbol: '£',
    currency_symbol: '€',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 240,
    name: 'United States',
    slug: 'united-states',
    iso: 'US',
    iso3: 'USA',
    flag: '🇺🇸',
    number_code: '840',
    phone_code: '1',
    currency: 'USD',
    currency_symbol: '$',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 241,
    name: 'United States Minor Outlying Islands',
    slug: 'united-states-minor-outlying-islands',
    iso: 'UM',
    iso3: null,
    flag: '',
    number_code: null,
    phone_code: '1',
    currency: '',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 242,
    name: 'Uruguay',
    slug: 'uruguay',
    iso: 'UY',
    iso3: 'URY',
    flag: '🇺🇾',
    number_code: '858',
    phone_code: '598',
    currency: 'UYU',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 243,
    name: 'Uzbekistan',
    slug: 'uzbekistan',
    iso: 'UZ',
    iso3: 'UZB',
    flag: '🇺🇿',
    number_code: '860',
    phone_code: '998',
    currency: 'UZS',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 244,
    name: 'Vanuatu',
    slug: 'vanuatu',
    iso: 'VU',
    iso3: 'VUT',
    flag: '🇻🇺',
    number_code: '548',
    phone_code: '678',
    currency: 'VUV',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 245,
    name: 'Venezuela',
    slug: 'venezuela',
    iso: 'VE',
    iso3: 'VEN',
    flag: '🇻🇪',
    number_code: '862',
    phone_code: '58',
    currency: 'VEF',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 246,
    name: 'Vietnam',
    slug: 'viet-nam',
    iso: 'VN',
    iso3: 'VNM',
    flag: '🇻🇳',
    number_code: '704',
    phone_code: '84',
    currency: 'VND',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 247,
    name: 'Virgin Islands, British',
    slug: 'virgin-islands-british',
    iso: 'VG',
    iso3: 'VGB',
    flag: '🇻🇬',
    number_code: '92',
    phone_code: '1284',
    currency: 'USD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 248,
    name: 'Virgin Islands, U.s.',
    slug: 'virgin-islands-us',
    iso: 'VI',
    iso3: 'VIR',
    flag: '🇻🇮',
    number_code: '850',
    phone_code: '1340',
    currency: 'USD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 249,
    name: 'Wallis And Futuna',
    slug: 'wallis-and-futuna',
    iso: 'WF',
    iso3: 'WLF',
    flag: '🇼🇫',
    number_code: '876',
    phone_code: '681',
    currency: 'XPF',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 250,
    name: 'Western Sahara',
    slug: 'western-sahara',
    iso: 'EH',
    iso3: 'ESH',
    flag: '',
    number_code: '732',
    phone_code: '212',
    currency: '',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 251,
    name: 'Yemen',
    slug: 'yemen',
    iso: 'YE',
    iso3: 'YEM',
    flag: '🇾🇪',
    number_code: '887',
    phone_code: '967',
    currency: 'YER',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 252,
    name: 'Zambia',
    slug: 'zambia',
    iso: 'ZM',
    iso3: 'ZMB',
    flag: '🇿🇲',
    number_code: '894',
    phone_code: '260',
    currency: 'ZMW',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
  {
    id: 253,
    name: 'Zimbabwe',
    slug: 'zimbabwe',
    iso: 'ZW',
    iso3: 'ZWE',
    flag: '🇿🇼',
    number_code: '716',
    phone_code: '263',
    currency: 'USD',
    currency_symbol: '',
    created_at: '2020-03-05 21:36:12',
    updated_at: '2020-05-16 23:06:23',
  },
];

export default countries;
